import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { CompanyRole, AccountType } from '@/app/api/api.model';

function isComplianceRole(account: { accountType: string; role: string; cluster: string | null; companyDto: { cluster: string | null } | null; companyRole: string | null } | null): boolean {
  if (!account) return false;
  const personalCluster = Boolean(account.cluster);
  const corporateCluster = Boolean(account.companyDto?.cluster);
  // const viewer = account.companyRole === CompanyRole.VIEWER;
  const personalCompliance = account.accountType === AccountType.PERSONAL && account.role === 'COMPLIANCE' && personalCluster;
  const companyCompliance = account.accountType === AccountType.CORPORATE && corporateCluster;
  return personalCompliance || companyCompliance;
}

export const complianceDefaultPageGuard: CanActivateFn = (route): UrlTree | boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const account = authService.accountDto();
  if (isComplianceRole(account)) {
    return router.createUrlTree(['/eis-signals'], {
      queryParams: route.queryParams
    });
  }
  return true;
};
